export const MODAL_TYPE = {
    SWISH_HANDEL: 'SWISH_HANDEL',
    TRUSTLY: 'TRUSTLY'
};

export const PAYMENT_OPTIONS = {
    CARD: 'Card',
    PAYPAL: 'PayPal',
    APPLEPAY: 'ApplePay',
    GOOGLEPAY: 'GooglePay',
    SWISH_HANDEL: 'SwishHandel',
    VISA_MASTERCARD: 'VisaMasterCard',
    KLARNA: 'Klarna',
    TRUSTLY: 'Trustly',
    WALLET: 'Wallet',
    NO_PAYMENT_METHOD: 'NoPaymentMethod'
};

export const PAYMENT_OPTION_STATUS = {
    AVAILABLE: 'Available',
    UNAVAILABLE_DUE_TO_AMOUNT: 'UnavailableDueToAmount',
    AVAILABLE_WITH_DISTURBANCE: 'AvailableWithDisturbance'
};

export const BUYER_PROTECTION_STATE = {
    NOT_SELECTED: 'NotSelected',
    NOT_ADDED: 'NotAdded',
    ADDED: 'Added'
};

export default () => {
    return {
        buyerMember: null,
        checkoutSummary: {
            hasError: false,
            isFetching: false
        },
        hasError: false,
        isFetching: false,
        payment: {
            hasError: false,
            isFetching: false,
            paymentOptions: null,
            selectedPayment: null,
            buyerProtection: BUYER_PROTECTION_STATE.NOT_SELECTED,
            orderCalculation: null,
            paymentMethodData: null,
            paymentMethodAmount: null,
            isValid: false,
            discountCodes: [],
            discountCodesValidating: false,
            showSelectedPaymentAsPayButton: false
        },
        sellerMember: null,
        modal: {
            open: '',
            paymentAttemptId: '',
            trustlyRedirectUrl: ''
        },
        ongoingPaymentAttempt: null,
        shippingInfo: {
            shippingOptions: null,
            shippingPriceRange: null,
            shippingDiscount: null,
            collectionPoints: null,
            selectedCollectionPoint: null,
            isBooked: false,
            isFetching: false
        },
        combinedShippingInfo: null,
        purchaseOrder: {},
        shippingOptionsLoading: false,
        verificationStatus: {
            needsKyc: false
        },
        preselectedValues: {
            shipping: null,
            paymentOption: null,
            buyerProtection: BUYER_PROTECTION_STATE.NOT_SELECTED,
            discountCode: null
        }
    };
};
